export const setCookie = (name: string, value: string) => {
  document.cookie = name + '=' + encodeURIComponent(value); // by default it expires at the end of session
};

/**
 * Set cookie with optional domain and max-age for cross-subdomain sharing.
 * Used for Meta tracking cookies (_fbc, _fbp) shared between bigdevsoon.me and app.bigdevsoon.me
 * If domain is undefined, browser uses current hostname automatically.
 */
export const setCookieWithDomain = (name: string, value: string, domain: string | undefined, maxAgeDays: number) => {
  const maxAgeSeconds = maxAgeDays * 24 * 60 * 60;
  const domainPart = domain ? `; domain=${domain}` : '';
  document.cookie = `${name}=${encodeURIComponent(value)}${domainPart}; path=/; max-age=${maxAgeSeconds}; SameSite=Lax`;
};

export const getCookie = (name: string) => {
  const cookies = document.cookie.split('; ');
  for (let i = 0; i < cookies.length; i++) {
    const cookieParts = cookies[i].split('=');
    const cookieName = decodeURIComponent(cookieParts[0]);
    const cookieValue = decodeURIComponent(cookieParts[1]);
    if (cookieName === name) {
      return cookieValue;
    }
  }
  return null;
};
export const deleteCookie = (name: string) => {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};
